$(->
  ## TODO: This looks to be part of the admin-side questionnaire edit form, but right now trying to open a form to edit it
  ## freezes the application, see https://www.pivotaltracker.com/story/show/150304101
  $(document).on 'change', '#questionnaire_timed', ->
    if $(this).is(':checked')
      $('#questionnaire_timeout_input').show()
    else
      $('#questionnaire_timeout_input').hide()
      $('#questionnaire_timeout').val(0)
  $('#questionnaire_timed').trigger('change')

  # ADMIN - EDIT JOB BUILDER & JOB BUILDER PRESCREEN QUESTIONS

  ## When question type is changed, shows and hides fields appropriately
  $(document).on 'change', '.scoring-question select.question_type', ->
    if $(this).val() == "0"
      $(this).closest('.scoring-question').find('select.weight').val("0").closest('.form-group.input').hide()
      $(this).closest('.scoring-question').find('.answers .remove_fields').click()
      $(this).closest('.scoring-question').find('.add_fields').hide()
    else
      $(this).closest('.scoring-question').find('select.weight').val("1").closest('.form-group.input').show()
      $(this).closest('.scoring-question').find('.add_fields').show()

  ## "(expand)" link next to questions
  $(document).on 'click', 'a.collapse_area', ->
    parent_selector = '.nested-fields'
    if $(this).data('parent')?
      parent_selector = $(this).data('parent')
    $(this).closest(parent_selector).find('.collapse').collapse('toggle')
    false

)
